<template>
    <div class="pageWrap" v-loading="loading"> 
        <div class="pagechange">
            <div class="redBlock"></div>
            <div class="headerText">行驶里程管理</div>
        </div>
        <div class="oildataPicker">
            <span class="name">日期</span>
            <el-date-picker
                v-model="value1"
                type="daterange"
                unlink-panels
                style="margin-left: 10px; margin-right: 10px"
                start-placeholder="选择开始日期"
                end-placeholder="选择结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
            </el-date-picker>
            <el-button type="danger" @click="confirm">确认</el-button>
        </div>
        <div class="left">
            <div class="size color1">
                <span class="date">{{dayMaxDate?dayMaxDate.replace('/','月')+'日':''}}</span>
                <span :class="heighmile*1>10000?'fontSize36':heighmile=='无数据'?'fontSize23':''">{{heighmile}}</span>
                <span class="column">单日最高里程</span>
            </div>
            <div class="size  color2">
                <span class="date">{{dayMinDate?dayMinDate.replace('/','月')+'日':''}}</span>
                <span :class="lowmile*1>10000?'fontSize36':lowmile=='无数据'?'fontSize23':''">{{lowmile}}</span>
                <span  class="column">单日最低里程</span>
            </div>
            <div class="size  color3">
                <span :class="avemile*1>10000?'fontSize36':avemile=='无数据'?'fontSize23':''">{{avemile}}</span>
                <span class="column">日均里程</span>
            </div>
            <div class="size  color4">
                <span :class="totalmile*1>10000?'fontSize36':totalmile=='无数据'?'fontSize23':''">{{totalmile}}</span>
                <span class="column">累计总里程</span>
            </div>
            <div class="unit">
                <span>单位：公里</span>
            </div>
        </div>
        <!-- <div class="line" style="height:500px;background-color:#E1E1E1;width:1px;margin-top:80px"></div> -->
        <div class="right">
            <div class="search-form-group">
                <el-radio-group v-model="period" size="medium" @change="periodChange">
                <el-radio-button label="0">按日</el-radio-button>
                <!-- <el-radio-button label="1">按周</el-radio-button> -->
                <el-radio-button label="2">按月</el-radio-button>
                </el-radio-group>
            </div>
            <div class="tableline">
                <EquipChart :chartOption="chartOption" height="500px"/>
            </div>
        </div>
    </div>
        
</template>
<script>
    import EquipChart from "../../../components/chart/line2";
    import {getEquipmentMileage,getEquipStatistics} from "../../../utils/api"
    import {dateTransfor1,dateTransfor} from "../../../utils/commons"
    import {Message} from 'element-ui'
    export default{
        data(){
            return{
                period:"0",
                chartOption:{},
                heighmile:'无数据',
                lowmile:'无数据',
                avemile:'无数据',
                totalmile:'无数据',
                dayMaxDate:'',
                dayMinDate:'',
                unit:'公里',
                loading:false,
                timer:0, //定时器id
                value1:[],
                pickerOptions: {
                    shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                    }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                    }],
                    disabledDate: (time) => {
                    return time.getTime() > Date.now();
                    }
                },
            }
        },
        props:["code","workIndex"],
        computed: {
        },
        created() {
            this.value1=[dateTransfor1(),dateTransfor()]
        },
        mounted() {
            // this.getMile();
            
        },
        components:{EquipChart},
        watch:{
            workIndex(val){
                if(val==2){
                    // this.getMile();
                    if(this.value1==null){
                        Message.warning('请选择时间段！')
                        return
                    }
                    this.getEquipmentMileageFun();
                    this.getEquipStatisticsFun();
                }
            },
            code(){
                this.value1=[dateTransfor1(),dateTransfor()]
                this.period=0
            }
        },
        methods:{
            confirm(){
                if(this.value1==null){
                    Message.warning('请选择时间段！')
                    return
                }
                this.getEquipmentMileageFun()
                this.getEquipStatisticsFun()
            },
            //获取四个方格数据
            getEquipStatisticsFun(){
                if(this.value1==null) this.value1=['','']
                let params={
                    equipCode:this.code,
                    type:1,
                    startTime:this.value1[0]+' 00:00:00',
                    endTime:this.value1[1]+' 23:59:59'
                }
                getEquipStatistics(params).then(res=>{
                    if(res.data.code==200){
                        let info=res.data.content.info
                        this.heighmile=info.dayMax==0?'无数据':(info.dayMax*1).toFixed(1);
                        this.lowmile=info.dayMin==0?'无数据':(info.dayMin*1).toFixed(1);
                        this.avemile=info.dayAverage==0?'无数据':(info.dayAverage*1).toFixed(1);
                        this.totalmile=info.total==0?'无数据':(info.total*1).toFixed(1);
                        this.dayMaxDate=info.dayMaxDate;
                        this.dayMinDate=info.dayMinDate;
                    }
                })
            },
            //获取图表数据
            getEquipmentMileageFun(){
                if(this.value1==null) this.value1=['','']
                let params={
                    equipCode:this.code,
                    mode:this.period,
                    startTime:this.value1[0],
                    endTime:this.value1[1]
                }
                this.loading=true
                getEquipmentMileage(params).then(res=>{
                    if(res.data.code==200){
                        let data=res.data.content.dataList
                        if(data.length==0){
                            this.chartOption={};
                        }else{
                            const xAxisList = data.map((item) => item.dateTag);
                            const series = [{
                                    name: "里程",
                                    type: "bar",
                                    barMaxWidth:16,
                                    data: data.map((item) => {
                                    return item.mileage;
                                    }),
                                    
                                }];
                            this.chartOption={
                                    dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
                                    legend: {
                                    data: ["里程",],
                                    right:"20%"
                                    },
                                    grid:{
                                        top:40,
                                        left:50
                                    },
                                    xAxis: [
                                    {
                                        type: "category",
                                        data: xAxisList,
                                        splitLine:{
                                        show:false
                                        },
                                        axisLabel:{
                                        lineStyle:{
                                            color: '#878787'
                                        }
                                        },
                                        axisLine:{
                                        lineStyle:{
                                            color:'#878787'
                                        }
                                        },
                                        axisTick:{
                                        show:false
                                        }
                                    },
                                    ],
                                    yAxis: [
                                    {
                                        type: 'value',
                                        name: 'km',
                                        // interval: '',
                                        splitLine:{
                                            show:false
                                        },
                                        axisLabel:{
                                            lineStyle:{
                                            color: '#878787'
                                            },
                                            formatter: '{value}'
                                        },
                                        axisLine:{
                                            lineStyle:{
                                            color:'#878787'
                                            }
                                        },
                                        axisTick:{
                                            show:false
                                        },
                                        
                                    },
                                    ],
                                    series: series,
                                };
                        }
                    }
                    this.loading=false
                })
            },
            periodChange(){
                // this.getMile();
                if(this.value1==null){
                    Message.warning('请选择时间段！')
                    return
                }
                this.getEquipmentMileageFun();
            },
            // getMile(){
            //     this.loading=true;
            //     this.timer=setTimeout(()=>{this.loading=false},5000)
            //    getEquipMilage({code:this.code,mode:this.period}).then(res=>{
            //        if(!res.data.content){
            //             this.heighmile="无数据";
            //             this.lowmile="无数据";
            //             this.avemile="无数据";
            //             this.totalmile="无数据";
            //             return;
            //         } 
            //         const info=res.data.content.info;
            //         this.heighmile=(info.max*1).toFixed(1);
            //         this.lowmile=(info.min*1).toFixed(1);
            //         this.avemile=(info.averge*1).toFixed(1);
            //         this.totalmile=(info.total*1).toFixed(1);
            //         this.loading=false
            //         clearTimeout(this.timer)
            //       }
            //    )}
        },
        
    }
    
</script>
<style lang="scss" scoped="">
    .pageWrap{
        width: 100%;
        height: 658px;
        display: flex;
        position: relative;
        .pagechange {
            position: absolute;
            left: 10px;
            top: 25px;
            display: flex;
            .redBlock {
                height: 18px;
                width: 3px;
                background-color: #e96b5a;
                margin-right: 8px;
            }
            .headerText {
                color: #404040;
                font-family: Noto Sans SC;
                font-weight: medium;
                font-size: 16px;
                line-height: 18px;
                letter-spacing: 0px;
                text-align: left;
                font-weight: bold;
            }
        }
        .oildataPicker{
            position: absolute;
            top: 65px;
            left: 8px;
            .name{
            font-size: 14px;
            }
        }
        .left{
        width: 458px;
        height: 658px;
        padding: 120px 0px 50px 0px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        .size{
            width: 213px;
            height: 213px;
            border-radius: 2px;
            margin: 0px 7px;
            font-size: 46px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #222222;
            display: flex;
            flex-direction: column;
            text-align: center;
            justify-content: center;
            .column{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #555555;
                padding-top: 20px;
            }
            .fontSize36{
                font-size: 36px;
            }
            .fontSize23{
                font-size: 23px;
            }
            .date{
                font-size: 16px;
            }
        }
        .color1{
             background: #EFEFF8;
        }
        .color2{
             background:#E5F0F9;
        }
        .color3{
             background: #F8F3E4;
        }
        .color4{
             background: #FAECEA;
        }
        .unit{
            margin-left: 15px;          
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #222222;
        }
        }
        .right{
            width: 1400px;
            height: 618px;
            padding-top: 62px;
            padding-left: 40px;
            .search-form-group {
            margin-left: 20px;
            }
            .tableline{
                width: 100%;
                height: auto;
                margin-top: 30px;
            }
        }
    }
</style>